// extracted by mini-css-extract-plugin
export default {"container":"BalanceSheet_container__1wZKR","tableContainer":"BalanceSheet_tableContainer__fdy+r"};